<div class="delete-dsp-source">
  <div class="delete-dsp-source__header">
    <h2 id="deactivationWarningTitle" class="delete-dsp-source__title">
      Are you sure you want to delete Source Schain?
    </h2>
    <div class="delete-dsp-source__close">
      <span
        nz-icon
        nzType="close"
        nzTheme="outline"
        (click)="onCloseModal()"
      ></span>
    </div>
  </div>

  <div class="delete-dsp-source__body-wrapper">
    <div class="delete-dsp-source__body">
      <p class="delete-dsp-source__lead">Deletion will:</p>
      <ul class="delete-dsp-source__list delete-dsp-source__list--actions">
        <li class="delete-dsp-source__item">
          <span>Permanently delete</span> this Source Schain file
        </li>
        <li class="delete-dsp-source__item">
          <span>Deactivate</span> - Source Schain matching on the following DSP
          endpoint(s): <span>{{ data.dspItems }}</span>
        </li>
      </ul>

      <p class="delete-dsp-source__notice">This action cannot be undone.</p>
    </div>
  </div>

  <div class="delete-dsp-source__footer">
    <button
      nz-button
      type="button"
      nzType="default"
      class="delete-dsp-source__btn delete-dsp-source__btn--secondary"
      (click)="onCloseModal()"
    >
      Go Back
    </button>
    <button
      nz-button
      type="button"
      nzType="primary"
      class="delete-dsp-source__btn delete-dsp-source__btn--primary"
      (click)="onConfirm()"
    >
      Confirm
    </button>
  </div>
</div>
